import { render, staticRenderFns } from "./PageShopGoods.vue?vue&type=template&id=798adb71&scoped=true"
import script from "./PageShopGoods.vue?vue&type=script&lang=js"
export * from "./PageShopGoods.vue?vue&type=script&lang=js"
import style0 from "./PageShopGoods.vue?vue&type=style&index=0&id=798adb71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798adb71",
  null
  
)

export default component.exports